import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import BotonVerificar from "../cuenta/botonVerificar";

function normalizado(valor, porDefecto = "") {
  return (valor && valor !== "NA") ? valor : porDefecto;
}

// Botón "Publicar servicio" + modal. Encadena, sin salir de esta página:
// 1) que el servicio esté completo, 2) info personal confirmada,
// 3) verificación de identidad (Didit). Si falta algo, el modal lo resuelve ahí mismo.
function ModalPublicar({ usuario, setUsuario, onPublicar, validarServicio, idServicio, deshabilitado }) {
  const [show, setShow] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [perfilForm, setPerfilForm] = useState(() => ({
    nombre: normalizado(usuario?.nombre),
    apellido: normalizado(usuario?.apellido),
    tipoIdentificacion: normalizado(usuario?.tipoIdentificacion, "Identificación nacional"),
    identificacion: normalizado(usuario?.identificacion),
    telefono: normalizado(usuario?.telefono),
    ciudad: normalizado(usuario?.ciudad),
  }));

  const erroresServicio    = show && typeof validarServicio === "function" ? validarServicio() : [];
  const servicioCompleto   = erroresServicio.length === 0;
  const perfilCompleto     = usuario?.perfilPersonalCompleto === true;
  const estadoVerificacion = usuario?.verificacionIdentidad?.estado;
  const verificado         = estadoVerificacion === "aprobado";
  const listoParaPublicar  = servicioCompleto && perfilCompleto && verificado;

  function cambiarCampoPerfil(campo, valor) {
    setPerfilForm(prev => ({ ...prev, [campo]: valor }));
  }

  async function handlePublicar() {
    setCargando(true);
    try { await onPublicar(); }
    finally { setCargando(false); }
  }

  async function handleGuardarPersonal() {
    const nombre         = perfilForm.nombre.trim();
    const apellido        = perfilForm.apellido.trim();
    const identificacion  = perfilForm.identificacion.trim();
    const telefono        = perfilForm.telefono.trim();
    const ciudad          = perfilForm.ciudad.trim();

    if (!nombre || !apellido) {
      return Swal.fire({ icon: "error", title: "Datos incompletos", text: "Por favor completa nombre y apellido.", customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" } });
    }
    if (!identificacion) {
      return Swal.fire({ icon: "error", title: "Datos incompletos", text: "Por favor completa tu identificación.", customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" } });
    }
    if (!telefono) {
      return Swal.fire({ icon: "error", title: "Datos incompletos", text: "Por favor completa tu teléfono.", customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" } });
    }
    if (!ciudad) {
      return Swal.fire({ icon: "error", title: "Datos incompletos", text: "Por favor completa tu ciudad.", customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" } });
    }

    const datos = {
      nombre, apellido, identificacion, telefono, ciudad,
      pais: normalizado(usuario?.pais, "Colombia"),
      tipoIdentificacion: perfilForm.tipoIdentificacion,
    };

    setCargando(true);
    try {
      await axios.post("/confirmar-info", {
        params: { cualInfo: "Personal", idUsuario: usuario.idUsuario, datos },
      });

      if (typeof setUsuario === "function") {
        setUsuario(prev => ({ ...(prev || usuario), ...datos, perfilPersonalCompleto: true }));
      }
    }
    catch (err) {
      console.log("Error guardando info personal desde el modal de publicar:", err);
      Swal.fire({ icon: "error", title: "No se pudo guardar", text: "Ocurrió un error guardando tu información. Intenta de nuevo.", customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" } });
    }
    finally {
      setCargando(false);
    }
  }

  return (
    <div>
      <button
        type="button"
        className="btn w-100 text-white"
        style={{ backgroundColor: 'var(--naranja-mapa)', borderColor: 'var(--naranja-mapa)' }}
        onClick={() => setShow(true)}
        disabled={deshabilitado}
      >
        <i className="bi bi-rocket-takeoff-fill me-2"></i>
        Publicar servicio
      </button>

      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {!servicioCompleto
              ? "Completa tu servicio antes de publicar"
              : listoParaPublicar
              ? "Publicar servicio"
              : !perfilCompleto
              ? "Completa tu información para publicar"
              : "Verifica tu identidad para publicar"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {!servicioCompleto ? (
            <div className="text-start" style={{ fontSize: 14, lineHeight: 1.6 }}>
              <p className="mb-2">Antes de publicar, completa lo siguiente:</p>
              <ul className="ps-3 mb-0">
                {erroresServicio.map((e, idx) => <li key={idx}>{e}</li>)}
              </ul>
            </div>
          ) : listoParaPublicar ? (
            <p className="mb-0">Cuando publiques, tu servicio pasará a revisión antes de mostrarse en el marketplace. ¿Deseas continuar?</p>
          ) : !perfilCompleto ? (
            <div>
              <p className="text-muted small mb-3">
                Necesitamos estos datos antes de publicar. <b>Una vez confirmados no podrás modificarlos</b>, así que revisa que estén bien escritos.
              </p>
              <div className="row g-2">
                <div className="col-6">
                  <input className="form-control" placeholder="Nombre" value={perfilForm.nombre} onChange={(e) => cambiarCampoPerfil("nombre", e.target.value)} disabled={cargando} />
                </div>
                <div className="col-6">
                  <input className="form-control" placeholder="Apellido" value={perfilForm.apellido} onChange={(e) => cambiarCampoPerfil("apellido", e.target.value)} disabled={cargando} />
                </div>
                <div className="col-6">
                  <select className="form-select" value={perfilForm.tipoIdentificacion} onChange={(e) => cambiarCampoPerfil("tipoIdentificacion", e.target.value)} disabled={cargando}>
                    <option value="Identificación nacional">Identificación nacional</option>
                    <option value="Pasaporte">Pasaporte</option>
                  </select>
                </div>
                <div className="col-6">
                  <input className="form-control" placeholder="Número de identificación" value={perfilForm.identificacion} onChange={(e) => cambiarCampoPerfil("identificacion", e.target.value)} disabled={cargando} />
                </div>
                <div className="col-6">
                  <input className="form-control" placeholder="Teléfono" value={perfilForm.telefono} onChange={(e) => cambiarCampoPerfil("telefono", e.target.value)} disabled={cargando} />
                </div>
                <div className="col-6">
                  <input className="form-control" placeholder="Ciudad" value={perfilForm.ciudad} onChange={(e) => cambiarCampoPerfil("ciudad", e.target.value)} disabled={cargando} />
                </div>
              </div>

              <p className="text-muted small mt-3 mb-0">
                Esto (y la verificación de identidad) solo te lo pedimos la primera vez que publicas un servicio. De aquí en adelante no lo vuelves a necesitar.
              </p>
            </div>
          ) : (
            <BotonVerificar usuario={usuario} setUsuario={setUsuario} idServicio={idServicio} />
          )}
        </Modal.Body>

        <Modal.Footer className="d-flex flex-column gap-2">
          {!servicioCompleto ? (
            <Button variant="primary" className="w-100" onClick={() => setShow(false)}>
              Entendido
            </Button>
          ) : listoParaPublicar ? (
            <Button variant="primary" className="w-100" onClick={handlePublicar} disabled={cargando}>
              {cargando ? "Publicando..." : "Sí, publicar servicio"}
            </Button>
          ) : !perfilCompleto ? (
            <Button variant="primary" className="w-100" onClick={handleGuardarPersonal} disabled={cargando}>
              {cargando ? "Guardando..." : "Guardar y continuar"}
            </Button>
          ) : null}
          {servicioCompleto && (
            <Button variant="outline-secondary" className="w-100" onClick={() => setShow(false)} disabled={cargando}>
              Cancelar
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ModalPublicar;
